'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/intl-messageformat-parser/index.js
// module id = 204
// module chunks = 0 1 2 4 5 6